import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import TransWithNda from 'components/TransWithNda';

import './ShareableLinkNdaRejected.styles.scss';

type ShareableLinkNdaRejectedProps = {
  className?: string;
};

const ShareableLinkNdaRejected: React.FC<ShareableLinkNdaRejectedProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('shareable-link-nda-rejected', className);

  const { t } = useTranslation();

  return (
    <ShareableLinkLockScreen
      className={classes}
      title={<TransWithNda i18nKey="ndaRejected" />}
      description={t('ndaRejectedDescription')}
    />
  );
};

export default ShareableLinkNdaRejected;
